module.exports = __webpack_public_path__ + "img/locked-profile.f2f90d55.svg";